import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme } from 'presto-mini-apps-lib';
import { TabberHeight } from '../../constants/appState';


class Tabber extends Component {
    render() {
        const {
            tabList,
            currentActiveTab,
            clickHandler = () => null,
        } = this.props;

        return ((!!tabList && tabList.length > 0) ? (
            <TabWrapper 
                className="tab-component"
                tabCount={tabList.length}
            >
                { tabList.map((item, key) => (
                    <li 
                        key={key}
                        className={(currentActiveTab === item.id ? 'active' : '')}
                        onClick={() => clickHandler(item.id)}
                    >
                        {/* <Link to={item.link}>{item.title}</Link> */}
                        <span>{item.title}</span>
                    </li>
                ))}
            </TabWrapper>
        ) : null);
    }
}

export default Tabber;


const TabWrapper = styled.ul`
    ${PrestoAppTheme.layout.blankListStyle}
    height: ${TabberHeight}px;
    background-color: ${PrestoAppTheme.colors.baseSnowLight};
    font-size: ${PrestoAppTheme.layout.fontSizeSmall};
    font-weight: 500;

    & > li {
        display: block;
        float: left;
        height: 100%;
        width: calc(100% / ${props => props.tabCount});
        border-bottom: 2px solid transparent;
        box-sizing: border-box;
        
        & > span {
            display: flex;
            height: 100%;
            width: 100%;
            padding: 0 ${PrestoAppTheme.layout.xSmallGap};
            align-items: center;
            justify-content: center;
            text-align: center;
            line-height: 1em;
            color: ${PrestoAppTheme.colors.baseGreyDark};
            box-sizing: border-box;
            cursor: pointer;
        }

        &.active {
            border-bottom: 2px solid ${PrestoAppTheme.colors.prestoRed};
        
            & a {
                color: ${PrestoAppTheme.colors.prestoRed};
            }
        }
    }
`;
